import { TabConfig } from '@/app/navigation/types'
import { DashboardTab } from '../tabs/dashboard'
import { ATraiterTab } from '../tabs/a-traiter'
import { DossierEnAttenteTab } from '../tabs/dossier-en-attente'
import { PlanningTab } from '../tabs/planning'
import { PreferencesTab } from '../tabs/preferences'
import { TasksTab } from '@/features/admin/tabs/mes-taches'
import { IATab } from '@/features/admin/tabs/ia'
import { TrackerTab } from '@/features/admin/tabs/tracker'

export const expertTabs: TabConfig[] = [
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    icon: 'HomeIcon',
    component: DashboardTab,
    path: '/expert/dashboard',
    position: 1,
    permissions: ['view_dashboard']
  },
  {
    id: 'a-traiter',
    label: 'À Traiter',
    icon: 'ClipboardDocumentCheckIcon',
    component: ATraiterTab,
    path: '/expert/a-traiter',
    position: 2,
    permissions: ['view_tasks']
  },
  {
    id: 'dossier-en-attente',
    label: 'Dossier en attente',
    icon: 'FolderIcon',
    component: DossierEnAttenteTab,
    path: '/expert/dossier-en-attente',
    position: 3,
    permissions: ['view_tasks']
  },
  {
    id: 'planning',
    label: 'Planning',
    icon: 'CalendarIcon',
    component: PlanningTab,
    path: '/expert/planning',
    position: 4,
    permissions: ['view_planning']
  },
  {
    id: 'mes-taches',
    label: 'Mes Tâches',
    icon: 'TaskIcon',
    component: TasksTab,
    path: '/expert/mes-taches',
    position: 5,
    permissions: ['manage_tasks']
  },
  {
    id: 'ia',
    label: 'IA',
    icon: 'SparklesIcon',
    component: IATab,
    path: '/expert/ia',
    position: 6,
    permissions: ['view_dashboard']
  },
  {
    id: 'tracker',
    label: 'Tracker',
    icon: 'ClipboardDocumentCheckIcon',
    component: TrackerTab,
    path: '/expert/tracker',
    position: 7,
    permissions: ['view_dashboard']
  },
  {
    id: 'preferences',
    label: 'Préférences',
    icon: 'CogIcon',
    component: PreferencesTab,
    path: '/expert/preferences',
    position: 8,
    permissions: ['manage_own_preferences']
  }

  // TODO: Add more tabs as they are implemented
  // {
  //   id: 'expertises',
  //   label: 'Expertises',
  //   icon: 'DocumentTextIcon',
  //   component: ExpertisesView,
  //   path: '/expert/expertises',
  //   position: 4,
  //   permissions: ['view_expertises']
  // }
]